<template>
  <div>
    <el-dialog 
      :visible.sync="dialogVisible" 
      :fullscreen="true" 
      top="0"
      custom-class="fullscreen-map-dialog"
      @opened="opened"
      :modal-append-to-body="false" 
      :close-on-press-escape="false" 
      :close-on-click-modal="false"
    >
      <div class="map-container">
        <gmap-map 
          ref="gmap"
          :zoom="mapOptions.zoom" 
          :center="mapOptions.center" 
          :options="{
            fullscreenControl: true,
            streetViewControl: true,
            mapTypeControl: true,
            zoomControl: true,
            gestureHandling: 'greedy'
          }"
          style="width: 100%; height: 100vh"
        >
          <gmap-marker
            :position="currentPlace"
            :clickable="true"
            :draggable="!readonly"
          ></gmap-marker>
        </gmap-map>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="click" v-if="!readonly">{{$t('Yadda_saxla')}}</el-button>
        <el-button size="small" @click="dialogVisible = false">{{$t('İmtina')}}</el-button>
        <p v-if="!currentPlace" class="location-warning">{{$t('Ünvan_hələ_tapılmayıb_Zəhmət_olmasa_bir_neçə_saniy')}}</p>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  // import { gmapApi } from "vue2-google-maps";
  export default {
  
    props: {
      readonly: { type: Boolean, default: false },
    },
    data() {
      return {
        // google: new gmapApi(),
        gmap: null,
        marker: null,
        currentPlace: null,
        dialogVisible: false,
        placeName: null,
        mapOptions: {
          zoom: 14,
          center: { lat: 40.385238, lng: 49.8215883 },
          scrollwheel: true,
        },
      };
    },
    methods: {
      show(lat, lng) {
        this.dialogVisible = true;
        if (lat && lng) {
          this.currentPlace = { lat: lat, lng: lng };
          this.mapOptions.center = this.currentPlace;
        } else this.currentPlace = null;
      },
      placeChanged(place) {
        if (!place.geometry) return;
        var location = new google.maps.LatLng(
          place.geometry.location.lat(),
          place.geometry.location.lng()
        );
        this.gmap.panTo(location);
      },
      value() {
        return this.marker;
      },
      opened() {
        this.geolocate();
      },
      click() {
        if (this.currentPlace) {
          this.warning = false;
          this.dialogVisible = false;
          this.$emit("selected", this.currentPlace);
        } else {
          this.warning = true;
        }
      },
      setPlace(lat, lng) {
        this.currentPlace = { lat: lat, lng: lng };
      },
      async geolocate() {
        const position = await new Promise(resolve => {
          navigator.geolocation.getCurrentPosition(position => resolve(position))
  
        });
        const location = {};
  
        async function findLocation() {
          const position = await new Promise(resolve => {
            navigator.geolocation.getCurrentPosition(position => resolve(position));
          });
  
          const geocoder = new google.maps.Geocoder();
          const latLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
  
          return new Promise((resolve, reject) => {
            geocoder.geocode({ 'latLng': latLng }, function (results, status) {
              if (status == google.maps.GeocoderStatus.OK) {
                if (results[0]) {
                  location.placeName = results[0].formatted_address;
                  resolve();
                } else {
                  reject("Not Found");
                }
              } else {
                reject("Geocode error: " + status);
              }
            });
          });
        }
  
        findLocation().then(() => {
          this.currentPlace = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
            placeName: location.placeName
          };
  
          this.marker = new google.maps.Marker({
            position: this.currentPlace,
            map: map,
          });
        }).catch(error => {
          console.error(error);
        });
  
  
  
        this.mapOptions.center.lat = position.coords.latitude;
        this.mapOptions.center.lng = position.coords.longitude;
  
        const that = this;
  
        const map = new google.maps.Map(
          document.getElementById("gmap"),
          this.mapOptions
        );
  
        this.gmap = map;
  
    
  
        if (!this.readonly)
          google.maps.event.addListener(map, function (e) {
            var location = e.latLng;
  
            var marker = new google.maps.Marker({
              position: location,
              map: map,
            });
  
            that.marker = marker;
  
            // that.setPlace(location.lat(), location.lng());
          });
      },
  
      clearMarkers() {
        if (this.marker) {
          this.marker.setMap(null);
          this.marker = null;
        }
      },
    },
  
    async mounted() {
      await this.$gmapApiPromiseLazy();
    }
  };
  </script>
<style lang="scss">
.fullscreen-map-dialog {
  width: 100% !important;
  height: 100vh !important;
  margin: 0 !important;
  padding: 0 !important;
  max-width: 100% !important;
  
  .el-dialog__header {
    padding: 20px;
    background: #fff;
    z-index: 1;
    position: relative;
  }
  
  .el-dialog__body {
    padding: 0 !important;
    height: calc(100vh - 120px) !important;
  }
  
  .map-container {
    height: 100%;
    width: 100%;
  }
  
  .location-warning {
    color: red;
    margin: 0 15px;
  }
  
  .dialog-footer {
    padding: 15px 20px;
    background: #fff;
    z-index: 1;
    position: relative;
  }
  
  .vue-map-container {
    height: 100% !important;
  }
}
</style>